import { render, staticRenderFns } from "./client-details-list-item.vue?vue&type=template&id=2b850214&scoped=true"
import script from "./client-details-list-item.vue?vue&type=script&lang=js"
export * from "./client-details-list-item.vue?vue&type=script&lang=js"
import style0 from "./client-details-list-item.vue?vue&type=style&index=0&id=2b850214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b850214",
  null
  
)

export default component.exports